import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { findProvinceFromAddress } from 'src/app/helpers/find-province-from-address.helper';
import { DeliveryProduct, TimePeriods } from 'src/app/models/delivery.schema';
import { Partner } from 'src/app/models/partner.schema';
import { Product } from 'src/app/models/product.schema';
import { ShopifySale } from 'src/app/models/shopify-sale.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { BusinessSaleService } from 'src/app/services/business-sale.service';
import { CakeSaleService } from 'src/app/services/cake-sale.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { PartnerService } from 'src/app/services/partner.service';
import { ProductService } from 'src/app/services/product.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-business-sale-form',
  templateUrl: './business-sale-form.component.html',
  styleUrls: ['./business-sale-form.component.scss']
})
export class BusinessSaleFormComponent implements OnInit {

  public sale: ShopifySale;
  public readonly formValidationMsgs;
  public businessSaleForm: any;
  public timePeriods = TimePeriods;
  public partners: Partner[];
  public products: Product[];
  public saleProducts: any;
  public from: string;
  public to: string;
  constructor(
    private route: ActivatedRoute,
    private businessSaleService: BusinessSaleService,
    private router: Router,
    private partnerService: PartnerService,
    private productService: ProductService,
    private _snackBar: MatSnackBar,
    private spinnerService: SpinnerService,
    private commanUsesService: CommanUsesService
  ) { 
    this.formValidationMsgs = ShopifySale.validationMessages;
  }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      this.businessSaleForm = new FormGroup(ShopifySale.validation());
      const saleId: string = this.route.snapshot.paramMap.get('id');
      if (saleId) {
        this.sale = await this.businessSaleService.getOne(saleId);
        this.saleProducts = JSON.parse(this.sale['lineItems']);
        [this.partners, this.products] = await Promise.all([
          this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners),
          this.productService.getAllActiveProductsForDelivery().then(res => res.products),
        ]);
      }
      this.patch();
      this.spinnerService.hide();
    } catch (error) {
      console.log('error :>> ', error);
      this.commanUsesService.showSnackBar('Errore nel recupero della vendita');
      this.spinnerService.hide();
    }
  }

  patch(){

    [
      'firstName', 
      'lastName', 
      'address', 
      'phone', 
      'total', 
      'paymentStatus', 
      'fullFillmentStatus', 
      'deliveryMethod', 
      'notes', 
      'intercom', 
      'deliveryTime', 
      'senderName', 
      'senderSurname', 
      'senderPhone', 
      'totalShippingAmount', 
      'totalPrice', 
      'totalLineItemsPrice',
      'deliveryDate',
      'personalizeNotes'
    ].forEach((param) => {
      this.businessSaleForm.controls[param].setValue(this.sale[param]);
      if(param === 'totalShippingAmount'){
        if(this.sale.totalShippingAmount) {
          this.businessSaleForm.controls.totalShippingAmount.setValue(this.sale.totalShippingAmount);
          return;
        }
        let shippingObject = JSON.parse(this.sale['totalShippingPriceSet']);
        if(shippingObject) {
          this.businessSaleForm.controls.totalShippingAmount.setValue(shippingObject.shop_money.amount);
        } else {
          this.businessSaleForm.controls.totalShippingAmount.setValue(0);
        }
      }
    });

    if(this.sale['deliveryDate']){
      this.businessSaleForm.controls['deliveryDate'].setValue(new DatePipe('it-IT').transform(this.sale['deliveryDate'], 'yyyy-MM-dd'));
    }

    if(this.sale['deliveryTime']){
      let [from, to] = this.sale['deliveryTime'].split("-");
      let fromTime = `${from}:00`;
      let toTime = `${parseInt(from)+1}:00`;
      let deliveryTime = fromTime + "-" + toTime;
      this.businessSaleForm.controls.deliveryTime.setValue(deliveryTime);
    }

    for(let p of this.partners){
      if(p.businessName.toLowerCase() == this.sale.vendor.toLowerCase()){
        this.businessSaleForm.controls.vendor.setValue(p.businessName);
        break;
      }
    }

    /* Set products */
    const control = <FormArray>this.businessSaleForm.get('deliveryProducts');
    control.clear();
    this.saleProducts.forEach((product) => {
      control.push(this.patchValues(product));
    });
    /* Set products */
  }

  patchValues(deliveryProduct: DeliveryProduct){
    let productForm = ShopifySale.productFormGroup();
    if (deliveryProduct['id']){
      productForm.controls.product.setValue({ name: deliveryProduct['name'], quantity: deliveryProduct['quantity'], sku: deliveryProduct['sku'], price: deliveryProduct['price'] });
    } else {
      productForm.controls.product.setValue({ name: deliveryProduct['name'], quantity: deliveryProduct['quantity'], sku: deliveryProduct['sku'], price: deliveryProduct['price'] });
    }
    return productForm;
  }

  addProduct() {
    const control = <FormArray>this.businessSaleForm.get('deliveryProducts');
    control.push(ShopifySale.productFormGroup());
  }

  removeProduct(index: number) {
    const control = <FormArray>this.businessSaleForm.get('deliveryProducts');
    control.removeAt(index);
  }

  async getAddress(place: any) {
    if (!this.businessSaleForm) return;
    this.businessSaleForm.controls.address.touched = true;
    this.businessSaleForm.controls.address.setValue(place.formatted_address || place.name || '');
    this.businessSaleForm.controls.latitude.setValue(place.geometry?.location?.lat() || '');
    this.businessSaleForm.controls.longitude.setValue(place.geometry?.location?.lng() || '');
    let province: string = findProvinceFromAddress(place);
    if(!province) {
      this.commanUsesService.showSnackBar("Province is not found with filled address, Please enter the address again.");
      return false;
    }
    this.businessSaleForm.controls.province.setValue(province);
  }

  /*
  getAddress(place: any) {
    if (!this.businessSaleForm) return;
    this.businessSaleForm.controls.address.touched = true;
    this.businessSaleForm.controls.address.setValue(place.formatted_address || place.name || '');
    this.businessSaleForm.controls.latitude.setValue(place.geometry?.location?.lat() || '');
    this.businessSaleForm.controls.longitude.setValue(place.geometry?.location?.lng() || '');
  }
  */

  directions(event:any){
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this.businessSaleForm.controls.address.value}`, '_blank');
  }

  onSubmit(e:any=[]){
    let sale: any = (new FormGroupToObject()).transform(this.businessSaleForm);
    let lineItems = new Array();
    for(let product of sale.deliveryProducts){
      lineItems.push(product.product);
    }
    sale.lineItems = JSON.stringify(lineItems);
    delete sale.channel;
    delete sale.status;
    delete sale.deliveryProducts;
    // sale.orderId = Math.floor(Math.random() * 90000) + 10000;
    // sale.status = 'New';
    // sale.channel = 'By App';
    sale.status = this.sale.status;
    sale.channel = this.sale.channel;
    sale.orderId = this.sale.orderId;
    // let promiseResult: any = this.cakeSaleService.create(sale);
    let promiseResult: any = this.businessSaleService.update(this.sale.id, sale);
    promiseResult.then((res: any) => {
      if(res){
        this._snackBar.open(`La nuova vendita viene creata con Id ` + res.orderId, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(result => {
          this.router.navigate(['/all/vendita']);
        });
      } else{
        this._snackBar.open(`Qualcosa è andato storto?`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(result => {
          this.router.navigate(['/all/vendita']);
        });
      }
    }).catch((err: any) => {
      console.log('err :>> ', err);
    })
  }

  getErrorMessages(): string[] {
    const errorMessages: string[] = [];

    Object.keys(this.businessSaleForm.controls).forEach(key => {
      const controlErrors = this.businessSaleForm.get(key)?.errors;
      if (controlErrors) {
        const fieldValidationMessages = ShopifySale.validationMessages[key];
        if (fieldValidationMessages) {
          Object.keys(controlErrors).forEach(errorKey => {
            const messageObj = fieldValidationMessages.find((msg) => msg.type === errorKey);
            if (messageObj) {
              if (key === 'address' && !errorMessages.includes('address')) {
                errorMessages.push('address');
              } else if (key !== 'address') {
                errorMessages.push(key);
              }
            }
          });
        }
      }
    });

    return errorMessages;
  }

  translateErrorMessage(error: string): string {
    const errorMessages: { [key: string]: string } = {
      address: 'VALIDARE INDIRIZZO',
      firstName: 'NOME',
      lastName: 'COGNOME',
      intercom: 'CITOFONO',
      deliveryDate: 'DATA',
      senderPhone: 'VALIDARE MITTENTE TELEFONO',
      senderSurname: 'VALIDARE MITTENTE COGNOME',
      senderName: 'VALIDARE MITTENTE NOME',
      province: 'VALIDARE PROVINCIA',
      totalShippingAmount: 'VALIDARE COSTO CONSEGNE',
      totalPrice: 'VALIDARE TOTALE',
      totalLineItemsPrice: 'VALIDARE PREZZO PUBBLICO',
    };
    return errorMessages[error] || '';
  }

}
